var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8081,
    cy: 17,
    rx: 16.8081,
    ry: 17,
    transform: "matrix(-1 0 0 1 33.9697 0)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8646_1862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2144 12.9066C25.0211 12.1751 24.4516 11.5991 23.7284 11.4036C22.4175 11.0483 17.1615 11.0483 17.1615 11.0483C17.1615 11.0483 11.9056 11.0483 10.5946 11.4036C9.8716 11.5991 9.30199 12.1751 9.1087 12.9066C8.75757 14.2323 8.75757 16.9984 8.75757 16.9984C8.75757 16.9984 8.75757 19.7645 9.1087 21.0901C9.30199 21.8215 9.8716 22.3976 10.5946 22.5931C11.9056 22.9483 17.1615 22.9483 17.1615 22.9483C17.1615 22.9483 22.4175 22.9483 23.7284 22.5931C24.4516 22.3976 25.0211 21.8215 25.2144 21.0901C25.5656 19.7645 25.5656 16.9984 25.5656 16.9984C25.5656 16.9984 25.5656 14.2323 25.2144 12.9066Z",
    fill: "#383A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4812 19.5476L19.848 16.9975L15.4812 14.4475V19.5476Z",
    fill: "#FAF7F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8646_1862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8081,
    height: 17,
    fill: "white",
    transform: "translate(8.75757 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d7cb09b0d6911ea0a93e19010d8728ef.svg";
export { ForwardRef as ReactComponent };